import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../lib/hook";
import { FormProps, useForm } from "antd/es/form/Form";

import { ICustomer } from "../../../../lib/features/customers/customers.constant";
import { Button, Form, Input, Modal } from "antd";
import { getDetailCustomerApi } from "../../../../apis/customer.api";
import { onUpdateCustomer } from "../../../../lib/features/customers/customers.thunk";
import { SuccessPopup } from "../../../../utilities/swal";

interface ModalUpdateCustomerProps {
  visible: boolean;
  onClose: () => void;
  id: string;
  update: () => void;
}

const ModalUpdateCustomer: React.FC<ModalUpdateCustomerProps> = (
  props: ModalUpdateCustomerProps
) => {
  const dispatch = useAppDispatch();
  const { onClose, visible, id, update } = props;
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState<ICustomer | null>(null);
  const [frontCID, setFrontCID] = useState<null | File>(null);
  const [backCID, setBackCID] = useState<null | File>(null);
  const [frontCIDPreview, setFrontCIDPreview] = useState<string | null>(null);
  const [backCIDPreview, setBackCIDPreview] = useState<string | null>(null);

  const [form] = useForm();
  const onFinish: FormProps<ICustomer>["onFinish"] = async (values) => {
    if (!customer) return;
    setLoading(true);

    const formData = new FormData();

    // ✅ So sánh từng field trong form với dữ liệu gốc
    Object.entries(values).forEach(([key, value]) => {
      const originalValue = (customer as any)[key];
      if (
        value !== originalValue &&
        value !== undefined &&
        value !== null &&
        value !== ""
      ) {
        formData.append(key, value);
      }
    });

    // ✅ Chỉ gửi file nếu người dùng upload mới
    if (frontCID) {
      formData.append("frontCID", frontCID);
    }
    if (backCID) {
      formData.append("backCID", backCID);
    }
    const hasData = Array.from(formData.entries()).length > 0;

    if (!hasData) {
      SuccessPopup("Không có gì thay đổi", "Bạn không có gì để thay đổi");
      setLoading(false);
      return;
    }
    await dispatch(onUpdateCustomer({ body: formData, id: id })).then(
      (result) => {
        if (result?.type.includes("fulfilled")) {
          update && update();
          form.resetFields();
          onClose && onClose();
          setLoading(false);
        }
      }
    );
    setLoading(false);
  };
  const handleGetDetailCustomer = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await getDetailCustomerApi(id);
      if (res?.data) {
        setCustomer(res?.data);
        if (res?.data.frontCID) setFrontCIDPreview(res?.data.frontCID);
        if (res?.data.backCID) setBackCIDPreview(res?.data.backCID);
      } else {
        setCustomer(null);
      }
    } catch (error) {
      console.error("Error fetching customer detail:", error);
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) {
      handleGetDetailCustomer();
      return () => {
        setCustomer(null);
        form.resetFields();
        setBackCID(null);
        setFrontCID(null);
        setLoading(false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  return (
    <Modal
      loading={loading}
      title="Cập nhật khách hàng"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form
        initialValues={customer ? customer : undefined}
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="mt-3"
      >
        <Form.Item<ICustomer>
          label="Tên gợi nhớ"
          name="shortName"
          rules={[{ required: true, message: "Mời điền chỗ trống" }]}
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
        <Form.Item<ICustomer>
          label="Họ và tên"
          name="fullName"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
        <Form.Item<ICustomer>
          label="Địa chỉ"
          name="address"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>

        <Form.Item<ICustomer>
          label="Điện thoại chính"
          name="majorPhone"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
        <Form.Item<ICustomer>
          label="Điện thoại phụ"
          name="minorPhone"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>

        <Form.Item<ICustomer>
          label="Email"
          name="email"
          style={{ marginBottom: 4 }}
        >
          <Input />
        </Form.Item>
      </Form>

      {/* <div className="grid grid-cols-1 gap-3 mt-3">
        {[
          {
            label: "CCCD mặt trước",
            file: frontCID,
            setFile: setFrontCID,
            preview: frontCIDPreview,
            setPreview: setFrontCIDPreview,
          },
          {
            label: "CCCD mặt sau",
            file: backCID,
            setFile: setBackCID,
            preview: backCIDPreview,
            setPreview: setBackCIDPreview,
          },
        ].map(({ label, file, setFile, preview, setPreview }, index) => (
          <div key={index} className="flex flex-col md:flex-row gap-2">
            <p className="min-w-[30%] ">{label}</p>
            <div className="flex flex-col gap-2 w-full border rounded-md p-3">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const selectedFile = e.target.files?.[0];
                  if (selectedFile && selectedFile.type.startsWith("image/")) {
                    setFile(selectedFile);
                    setPreview(URL.createObjectURL(selectedFile));
                  } else {
                    alert("Vui lòng chọn đúng định dạng ảnh.");
                    e.target.value = "";
                  }
                }}
              />
              {preview && (
                <div className="flex flex-col gap-2">
                  <img
                    src={preview}
                    alt={`preview-${label}`}
                    className="w-36 h-36 object-cover rounded border border-gray-300"
                  />
                
                  {file && (
                    <Button
                      onClick={() => {
                        setFile(null);
                        
                        if (label === "CCCD mặt trước" && customer?.frontCID) {
                          setPreview(customer.frontCID);
                        } else if (
                          label === "CCCD mặt sau" &&
                          customer?.backCID
                        ) {
                          setPreview(customer.backCID);
                        } else {
                          setPreview(null);
                        }
                      }}
                      danger
                    >
                      Xóa
                    </Button>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div> */}
    </Modal>
  );
};

export default ModalUpdateCustomer;
